import React from "react";
import { FOOTER } from "../mock";

export default function Footer() {
  return (
    <footer className="relative sep-top py-14">
      <div className="mx-auto max-w-3xl px-6 md:px-10 text-center">
        <img
          src="/shyft-coalition-logo.jpg"
          alt="SHYFT Coalition"
          className="mx-auto h-20 w-20 rounded-2xl object-cover"
          style={{ boxShadow: "0 14px 34px -10px rgba(32,24,80,0.35)" }}
        />
        <p className="mt-5 text-sm italic" style={{ color: "rgba(32,24,80,0.7)" }}>
          This webpage is sponsored by the{" "}
          <a href="https://shyftasap.com/" target="_blank" rel="noopener noreferrer" data-testid="footer-sponsor-link" className="font-semibold not-italic" style={{ color: "#9A6E1C" }}>{FOOTER.sponsor}</a>
          <span className="trademark-mark trademark-gold" data-testid="footer-sponsor-trademark" aria-label="trademark">™</span>
        </p>
        <div className="mt-6 pt-5" style={{ borderTop: "1px solid rgba(32,24,80,0.1)" }}>
          <p className="text-xs" data-testid="footer-copyright" style={{ color: "rgba(32,24,80,0.5)" }}>
            <span className="block">
              &copy; {new Date().getFullYear()} SHYFT Coalition
              <span className="trademark-mark" data-testid="footer-copyright-trademark" aria-label="trademark">™</span>
            </span>
            <span className="mt-1 block">All Rights Reserved.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
